import { usePageNumber } from 'hooks/usePageNumber';
import staticUrl from 'components/helpers/statics';

const CURRENT_YEAR = new Date().getFullYear();

const R = () => <sup style={{fontSize: 'small'}}>&reg;</sup>;

export default function Page({number, children}) {
  const pageNumber = usePageNumber();

  return (
    <div className="page">
      <div className="page-header">
        <img src={staticUrl('GEOAPP_LOGO')} className="uk-float-right logo" />
        <h1>MAGNUM<R/> GeoApp<R/> <small>v{VERSION}</small></h1>
        <h2>PILE DESIGN SUMMARY REPORT</h2>
      </div>
      <div className="page-content">
        { children }
      </div>
      <div className="page-footer">
        <p>
          <strong>Magnum Piering, Inc.</strong><br />
          156 Circle Freeway Dr.<br />
          Cincinnati, OH 45246<br />
          800-822-7437<br />
          www.magnumpiering.com
        </p>

        <p>MAGNUM GeoApp<sup>&reg;</sup> Software, Version {VERSION}, Copyright {CURRENT_YEAR}.&nbsp; <b>Page MP{number ?? pageNumber}</b></p>
      </div>
    </div>
  );
}
